'use client';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '~/GlobalRedux/store';

const initialState: boolean = false;

const smallLoadingSlice = createSlice({
  name: 'smallLoading',
  initialState,
  reducers: {
    setSmallLoading: (_state, action: PayloadAction<boolean>) => {
      return action.payload;
    },
  },
});

export const { setSmallLoading } = smallLoadingSlice.actions;
export default smallLoadingSlice.reducer;
export const smallLoadingSelector = (state: RootState) => state.loading;
